﻿export type NotificationType =
    | 'assign'
    | 'status'
    | 'delegate'
    | 'attach'
    | 'priority'
    | 'deadline'
    | 'comment'
    | 'mention'

export type NotificationGroup =
    | 'today'
    | 'yesterday'
    | 'earlierThisWeek'
    | 'earlierThisMonth'

export type NotificationTab = 'task' | 'erp' | 'crm'

export interface NotificationMeta {
    kind: 'status' | 'priority' | 'file'
    from?: string
    to?: string
    fromColor?: string
    toColor?: string
    // Сырые ключи статусов из details — по ним подтягиваются название и цвет из статусов проекта.
    fromKey?: string
    toKey?: string
    label?: string
    // Для вложений: прямая ссылка и/или id — чтобы открыть файл по клику на бейдж.
    fileUrl?: string
    attachmentId?: number | string
}

export interface NotificationRow {
    id: string
    tab: NotificationTab
    type: NotificationType
    author: string
    avatarUrl?: string | null
    action: string
    target: string
    meta?: NotificationMeta
    createdAtMs: number
    group: NotificationGroup
    taskLink?: string | null
    taskId?: number | string | null
    projectId?: string | null
    unread?: boolean
    warning?: boolean
}

export const NOTIFICATION_GROUP_ORDER: NotificationGroup[] = [
    'today',
    'yesterday',
    'earlierThisWeek',
    'earlierThisMonth',
]

export const NOTIFICATION_GROUP_LABELS: Record<NotificationGroup, string> = {
    today: 'Сегодня',
    yesterday: 'Вчера',
    earlierThisWeek: 'Ранее на этой неделе',
    earlierThisMonth: 'Ранее в этом месяце',
}

export const NOTIFICATION_TABS: { key: NotificationTab; label: string }[] = [
    { key: 'task', label: 'COR TASK' },
    { key: 'erp', label: 'COR ERP' },
    { key: 'crm', label: 'COR CRM' },
]

const HOUR = 60 * 60 * 1000
const now = Date.now()

// Демо-уведомления (набор из макета Figma): показываются, пока бэкенд возвращает пустой список.
export const MOCK_NOTIFICATIONS: NotificationRow[] = [
    {
        id: 'mock-1',
        tab: 'task',
        type: 'assign',
        author: 'Екатерина Иванова',
        action: 'Назначил(а) вам задачу:',
        target: 'Розділ Преміум ч.2',
        createdAtMs: now,
        group: 'today',
        unread: true,
    },
    {
        id: 'mock-2',
        tab: 'task',
        type: 'status',
        author: 'Екатерина Иванова',
        action: 'Изменил(а) статус в:',
        target: 'Розділ Преміум ч.2',
        meta: {
            kind: 'status',
            from: 'To do',
            to: 'In review',
            fromColor: '#F04438',
            toColor: '#453CFB',
        },
        createdAtMs: now - 8 * 60 * 1000,
        group: 'today',
        unread: true,
    },
    {
        id: 'mock-3',
        tab: 'task',
        type: 'delegate',
        author: 'Екатерина Иванова',
        action: 'Поручил(а) вам задачу:',
        target: 'Зробити прототип',
        createdAtMs: now - 5 * HOUR,
        group: 'today',
    },
    {
        id: 'mock-4',
        tab: 'task',
        type: 'attach',
        author: 'Екатерина Иванова',
        action: 'Прикрепил(а) файл в:',
        target: 'Какое-то название задачи',
        meta: {
            kind: 'file',
            label: 'Бриф на дизайн сайта (для всех)',
        },
        createdAtMs: now - 16 * HOUR,
        group: 'yesterday',
    },
    {
        id: 'mock-5',
        tab: 'task',
        type: 'priority',
        author: 'Екатерина Иванова',
        action: 'Изменил(а) приоритет в:',
        target: 'Какое-то название задачи',
        meta: {
            kind: 'priority',
            from: 'Средний',
            to: 'Высокий',
            fromColor: '#458CF6',
            toColor: '#E78D07',
        },
        createdAtMs: now - 20 * HOUR,
        group: 'yesterday',
    },
    {
        id: 'mock-6',
        tab: 'task',
        type: 'deadline',
        author: 'Предупреждение (?)',
        action: 'Истекает срок выполнения задачи:',
        target: 'Розробити скріни верифікації',
        createdAtMs: now - 20 * HOUR,
        group: 'yesterday',
        warning: true,
    },
    {
        id: 'mock-7',
        tab: 'task',
        type: 'priority',
        author: 'Екатерина Иванова',
        action: 'Изменил(а) приоритет в:',
        target: 'Какое-то название задачи',
        meta: {
            kind: 'priority',
            from: 'Средний',
            to: 'Высокий',
            fromColor: '#458CF6',
            toColor: '#E78D07',
        },
        createdAtMs: now - 4 * 24 * HOUR,
        group: 'earlierThisWeek',
    },
    {
        id: 'mock-8',
        tab: 'task',
        type: 'status',
        author: 'Екатерина Иванова',
        action: 'Изменил(а) статус в:',
        target: 'Какое-то название задачи',
        meta: {
            kind: 'status',
            from: 'In progress',
            to: 'Done',
            fromColor: '#F79009',
            toColor: '#12B76A',
        },
        createdAtMs: now - 12 * 24 * HOUR,
        group: 'earlierThisMonth',
    },
    {
        id: 'mock-9',
        tab: 'erp',
        type: 'assign',
        author: 'Екатерина Иванова',
        action: 'Добавил(а) вас в проект:',
        target: 'COR ERP Онбординг',
        createdAtMs: now - 2 * HOUR,
        group: 'today',
        unread: true,
    },
]
